module.exports = __webpack_public_path__ + "img/logo-playstore.1eed7167.svg";